<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchParams" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item :label="$t('Staff.Staffid')">
                    <el-input v-model="searchParams.userAccount" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Staff.StaffName')">
                    <el-input v-model="searchParams.userName" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
            </el-form>
            <template slot="btns">
                <div style="float:right">
                    <el-button size="small" type="primary" @click="searchTable">{{$t('base.search')}}</el-button>
                    <el-button size="small" @click="clearSelect">{{$t('base.Reset')}}</el-button>
                </div>
            </template>
        </SearchBox>
        <LabelContent :title="$t('Staff.StaffList')" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()">{{$t('Staff.AddStaff')}}</el-button>
                <!-- <el-button size="small" type="success" @click="exportShift">导出</el-button> -->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="userAccount" :label="$t('Staff.Staffid')" show-overflow-tooltip/>
                <el-table-column prop="userName" :label="$t('Staff.StaffName')" show-overflow-tooltip/>
                <el-table-column prop="depName" :label="$t('Branch.BranchName')" show-overflow-tooltip/>
                <el-table-column prop="ssoName" :label="$t('Department.DepartmentName')" show-overflow-tooltip/>
                <el-table-column prop="sfName" :label="$t('Staff.duty')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <!-- <span style="color:#417DF5" v-if="scope.row.liableUser">{{$t('Staff.Foreman')}}</span>
                        <span style="color:#18AE13" v-else>{{$t('demo.menu.Staff')}}</span> -->
                        <span style="color:#417DF5" v-if="scope.row.liableUser">班组长</span>
                        <span style="color:#18AE13" v-else>员工</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="150">
                    <template slot-scope="scope">
                        <span v-for="acc in access" :key="acc">
                            <span v-if="acc=='FOREMAN'" :class="scope.row.liableUser ? 'appoint' : 'noappoint'"
                                @click="saveClass(scope.row)">
                                <!-- {{scope.row.liableUser ? $t('Staff.CancelForeman') : $t('Staff.AppointForeman')}} -->
                                {{scope.row.liableUser ? '取消班组长' : '委任班组长'}}
                            </span>
                        </span>
                        <i class="delBtn iconfont u-shanchu"
                           v-if="sectionOfficeShow || (scope.row.liableUser != userInfo.userAccount)"
                           @click="deleteRow(scope.row)"/>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
        <el-dialog :title="ifAdd ? $t('base.add') : $t('base.update')" width="750px" :visible.sync="updateShow" style="text-align: left">
            <div>
                <el-form slot="form" :inline="true" ref="searchParams" :model="searchParams" label-width="80px"
                         class="unitWidth" size="small">
                    <el-form-item :label="$t('Staff.Staffid')">
                        <el-input v-model="userAccount" :placeholder="$t('base.PleaseEnter')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Staff.StaffName')">
                        <el-input v-model="userName" :placeholder="$t('base.PleaseEnter')"></el-input>
                    </el-form-item>
                    <div style="float:right">
                        <el-button size="small" type="primary" @click="searchNoStaff()">{{$t('base.search')}}</el-button>
                        <el-button size="small" @click="clearStaff()">{{$t('base.Reset')}}</el-button>
                    </div>
                </el-form>
                <LabelContent :title="$t('Staff.StaffList')" ref="LabelContent">
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="noStaffData" class="center" height="30vh"
                              @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55"/>
                        <el-table-column prop="userAccount" :label="$t('Staff.Staffid')" show-overflow-tooltip/>
                        <el-table-column prop="userName" :label="$t('Staff.StaffName')" show-overflow-tooltip/>
                    </el-table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" @click="updateShift('shiftForm')">{{ ifAdd ? $t('base.add') : $t('base.update') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { addShift, delShift, editShift, getAllShift } from '../../../libs/api'

    export default {
        name: 'shiftList',
        data() {
            return {
                updateShow: false,
                ifAdd: false,
                userInfo: {},
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0,
                    userAccount: '',
                    userName: ''
                },
                fcIdSelected: '',
                staffName: '',
                factoryTree: [],
                tableData: [],
                noStaffData: [],
                shiftForm: {
                    sfName: String
                },
                rules: {
                    fcCode: [
                        {
                            required: true,
                            message: '所属工厂',
                            trigger: 'blur'
                        }
                    ],
                    sfName: [
                        {
                            type: 'string',
                            required: true,
                            message: '所属班次',
                            trigger: 'blur'
                        }
                    ],
                    sfCode: [
                        {
                            type: 'string',
                            required: true,
                            message: '班次编码',
                            trigger: 'blur'
                        }
                    ],
                    sfStartHour: [
                        {
                            required: true,
                            message: '班次开始时间（时）',
                            trigger: 'blur'
                        }
                    ],
                    sfStartMinute: [
                        {
                            required: true,
                            message: '班次开始时间（分）',
                            trigger: 'blur'
                        }
                    ],
                    sfEndHour: [
                        {
                            required: true,
                            message: '班次结束时间（时）',
                            trigger: 'blur'
                        }
                    ],
                    sfEndMinute: [
                        {
                            required: true,
                            message: '班次结束时间（分）',
                            trigger: 'blur'
                        }
                    ]
                },
                factoryData: [],
                access: [],
                role: [],
                ischeck: true,
                scopeDisabled: '',
                isclear: false,
                ssoId: '',
                userIds: '',
                userName: '',
                userAccount: '',
                staffInfo: {},
                sectionOfficeShow: true
            }
        },
        mounted() {
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            this.userInfo = this.$store.state.userInfo
            if (this.$route.params.row) {
                this.staffInfo = this.$route.params.row
                sessionStorage.setItem('editStaff', JSON.stringify(this.staffInfo))
            } else {
                this.staffInfo = JSON.parse(sessionStorage.getItem('editStaff'))
            }
            this.searchTable()
            this.getDeptSectionLiableUser()
        },
        methods: {
            getDeptSectionLiableUser() {
                this.sectionOfficeShow = true
                let options = {
                    methods: 'GET',
                    url: this.$api.getDeptSectionLiableUser,
                    params: {
                        fcCode: this.staffInfo.fcCode,
                        userAccount: this.userInfo.userAccount
                    }
                }
                let self = this
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data) {
                            let sectionOfficeInfo = response.data
                            self.sectionOfficeShow = false
                        }
                    }
                })
            },
            handleSelectionChange(val) {
                this.userIds = ''
                let userList = []
                if (val.length > 0) {
                    for (let i = 0; i < val.length; i++) {
                        userList.push(val[i].userId)
                    }
                    this.userIds = userList.join(',')
                }
                console.log(this.userIds)
            },
            clearSelect() {
                this.fcIdSelected = ''
                this.staffName = ''
                this.searchTable()
            },
            clearStaff() {
                this.userAccount = ''
                this.userName = ''
                this.searchNoStaff()
            },
            /**
             *查询用户列表
             *  查询参数对象 searchParams
             **/
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page,
                    ssoId: this.staffInfo.ssoId
                }
                if (this.searchParams.userAccount != null && this.searchParams.userAccount != '') {
                    queryParams['userAccount'] = this.searchParams.userAccount
                }
                if (this.searchParams.userName != null && this.searchParams.userName != '') {
                    queryParams['userName'] = this.searchParams.userName
                }
                let options = {
                    method: 'GET',
                    params: queryParams,
                    url: this.$api.getStaff
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            searchNoStaff() {
                let queryParams = {}
                if (this.userAccount != null && this.userAccount != '') {
                    queryParams['userAccount'] = this.userAccount
                }
                if (this.userName != null && this.userName != '') {
                    queryParams['userName'] = this.userName
                }
                if (this.staffInfo.fcCode) {
                    queryParams['fcCode'] = this.staffInfo.fcCode
                }
                let options = {
                    method: 'GET',
                    params: queryParams,
                    url: this.$api.getNoStaff
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.noStaffData = response.data
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            updatehOpen(row) {
                this.userAccount = ''
                this.userName = ''
                this.searchNoStaff()
                if (this.ifAdd) {
                    //新增
                    this.shiftForm = {}
                    if (this.ischeck) {
                        this.shiftForm.fcCode = this.userInfo.fcCode
                    }
                    this.updateShow = true
                } else {
                    //编辑
                    this.shiftForm = JSON.parse(JSON.stringify(row))
                    this.updateShow = true
                }
            },
            updateShift(shiftForm) {
                if (this.ifAdd) {
                    // console.log(this.shiftForm)
                    if (!this.userIds) {
                        this.$message.error(this.$t('Staff.selectStaff'))
                        return
                    }
                    let queryParams = {
                        ssoId: this.staffInfo.ssoId,
                        userIds: this.userIds
                    }
                    let options = {
                        method: 'POST',
                        showLoading: true,
                        url: this.$api.addStaff,
                        params: queryParams
                    }
                    this.$http.request(options).then(response => {
                        if (response.status == 100) {
                            this.$message.success(this.$t('base.SuccessfullyAdded'))
                            this.updateShow = false
                            this.searchTable()
                            // this.searchNoStaff()
                        } else {
                            this.$message.error(response.message)
                        }
                    })
                } else {
                    this.$refs[shiftForm].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                showLoading: true,
                                url: this.$api.editShift,
                                data: this.shiftForm
                            }
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    this.$message.success(this.$t('base.SuccessfullyUpdated'))
                                    this.updateShow = false
                                    this.searchTable()
                                } else {
                                    this.$message.error(response.message)
                                }
                            })
                        } else {
                            return false
                        }
                    })
                }
            },
            selectChange() {
                this.$forceUpdate()
            },
            deleteRow(row) {
                // if (row.liableUser) {
                //     this.$message.error('班组长不能删除！！！')
                //     return
                // }
                this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
                    confirmButtonText: this.$t('base.delete'),
                    cancelButtonText: this.$t('base.cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                headers: { 'content-type': 'application/json' },
                                params: { userId: row.userId },
                                url: this.$api.delStaff
                            })
                            .then(response => {
                                this.searchTable()
                                this.searchNoStaff()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.searchTable()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.searchTable()
                        this.$message({
                            type: 'info',
                            message: this.$t('msg.cancel')
                        })
                    })
            },
            saveClass(row) {
                let str = ''
                if (row.liableUser) {
                    str = this.$t('Staff.notTips')
                } else {
                    str = this.$t('Staff.isTips')
                }
                this.$confirm(str, this.$t('msg.Tips'), {
                    confirmButtonText: this.$t('base.confirm'),
                    cancelButtonText: this.$t('base.cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                headers: { 'content-type': 'application/json' },
                                params: {
                                    ssoId: row.ssoId,
                                    userId: row.userId,
                                    isLiableUser: row.liableUser ? true : false
                                },
                                url: this.$api.editStaff
                            })
                            .then(response => {
                                if (response.status == 100) {
                                    this.searchTable()
                                    this.getDeptSectionLiableUser()
                                } else {
                                    this.$message.error(response.message)
                                }
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.searchTable()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.searchTable()
                        this.$message({
                            type: 'info',
                            message: this.$t('msg.canceled')
                        })
                    })
            },
            async exportShift() {
                let params = {}
                if (this.fcIdSelected != null && this.fcIdSelected != '') {
                    params['fcCode'] = this.fcIdSelected
                }
                let options = {
                    url: this.$api.exportShift,
                    method: 'POST',
                    params: params,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '班次信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            }
        }
    }
</script>

<style lang="scss" scoped>
    .appoint {
        color: #F5A850;
        cursor: pointer;
        text-decoration: underline;
    }

    .noappoint {
        color: #417DF5;
        cursor: pointer;
        text-decoration: underline;
    }
</style>
